import React, { Component } from "react";

import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';

//material components
import Paper from '@material-ui/core/Paper';

//Actions

class ModalCloseRepairs extends Component {
    constructor(props){
        super();
        this.state={
            open : false, 
            //Resize
            rootFontSize:{
                name:'xs',
                fontSize:'58%',
                maxWidht:970,            
            },            
        };
    }

    componentWillMount(){
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({isMobile: window.innerWidth <= 960});

        const sizes={
           xs: {
                name:'xs',
                fontSize:'58%',
                maxWidht:600,            
            },
            sm: {
                name:'sm',
                fontSize:'60%',
                maxWidht:1024,            
            },
            md: {
                name:'md',
                fontSize:'80%',
                maxWidht:1880,            
            },
            lg: {
                name:'lg',
                fontSize:'100%',
                maxWidht:1920,            
            },
        };
   
        const windowWidht = window.innerWidth ;
        const windowHeiht = window.innerHeight;
   
        let rootFontSize= sizes.xs;
   
        if(windowWidht > sizes.md.maxWidht){
            rootFontSize=  sizes.lg;
        }else if(windowWidht > sizes.sm.maxWidht){
            rootFontSize=  sizes.md;
        }else if(windowWidht > sizes.xs.maxWidht){
            rootFontSize=  sizes.sm;
        }else {
            rootFontSize=  sizes.xs;
        }
   
   
        this.setState({
            rootFontSize: rootFontSize,
            windowWidht:windowWidht,
            windowHeiht:windowHeiht,
        });
    }

 
    //#region  Handlers 
    CleanScheduleModal = () =>{

    };
    //#endregion

    //#region  Inner components
    RenderModalContent = ({actions}) =>{
        
        return ( 
        <Grid>                    
            <Paper elevation={3} className="LPaperModalRepairs" square='false' color='secondary'>
                <Grid id='close/cancel_repair_modal' container justifyContent='flex-start' alignItems='baseline' style={{height:'100%'}} > 
                    <Grid item container  alignItems='center' className="LTitleRepairsModal">{this.props.isCancel===false?'Confirm Repair Completion':'Confirm Repair Cancellation'}</Grid>
                    <Grid item container className="LRepairsModalContainer">
                        <Grid item container justifyContent='flex-start' alignItems='center' className="LSubtitleRepairsModal"> 
                            {this.props.isCancel===false? 'Are you sure the following repair request(s) is complete?':'Are you sure you want to cancel the following repair request(s)?'}
                        </Grid>
                        <Grid item container justifyContent='center' alignItems='flex-start' className="ModalActionsContainer">
                            <this.RenderActions actions={actions}/>
                        </Grid>
                        <Grid item container className="ModalButtonsContainer alingCenter" justifyContent='flex-end'>
                                <this.RenderButtonsContainer/>
                        </Grid> 
                    </Grid>   
                </Grid>
            </Paper>
        </Grid>
        );
    };

    RenderActions = ({actions}) =>{        

        return(
            <Grid item container justifyContent='center' alignItems='center' xs={11}>
                <Grid item container justifyContent='center' alignItems='center' style={{overflow:'hidden'}}>

                    {
                        (actions && actions.length > 0) ?
                        actions.map( 
                            (action, index) =>{
                                return (
                                    <this.RenderSingleAction key={`completeModalAction_${index}`} action ={action}/>
                                );
                            }
                        )

                        :
                        <Grid></Grid>
                    }
                </Grid>
            </Grid>
        );

    };

    RenderSingleAction = ({action}) =>{
        
        return(
            (action)?
            <Grid id={`repair_${action._id}`} item container className="padding5">
                <Grid item container className="LRepairAction alingCenter">
                    <Grid item container xs={3}>
                        <this.RenderImageComponent action={action}/>
                    </Grid>
                    <Grid item container xs={5}>
                        <this.RenderZoneNameComponent  action={action}/>
                    </Grid>
                    <Grid item container xs={4}>
                        <this.RenderIssueComponent  action={action}/>
                    </Grid>
                </Grid>
            </Grid>
            :
            <Grid></Grid>
        );
    };

    RenderImageComponent = ({action}) =>{

        return(
            <Grid item container className="alingCenter" >
            {
                (action.resident && action.resident.residentPictureUrl)?
                    <img
                        className="residentImageModal"
                        src={action.resident.residentPictureUrl}
                        alt={action.resident.name}
                    />
                    :
                    <Grid item className="LAltResidentName">{action.resident.name}</Grid>
            }
            </Grid>
        );
    };

    RenderZoneNameComponent = ({action}) =>{

        return(
            <Grid item container className="LZoneName alingCenter">
                {
                    (action.resident && action.resident.zoneName)?
                    action.resident.zoneName
                    :
                    'N/A'
                }
            </Grid>
        );
    };

    RenderIssueComponent = ({action}) =>{
        let itemName = action && action.item && action.item.name ? action.item.name : '';

        if(itemName){
            itemName = itemName.charAt(0).toUpperCase()+ itemName.slice(1);
        }

        return(
            <Grid item container className='alingCenter'>
                {
                    (action.issue && action.item.iconUrl)?
                        <Grid item container className="alingCenter" >
                            <img
                                className="LItemImg"
                                src={action.item.iconUrl}
                                alt={action.item.name}
                            />
                        </Grid>
                        :
                        <Grid></Grid>
                }
                <Grid item container className="LItemName alingCenter">
                    {itemName}
                </Grid>
            </Grid>
        );
    };

    RenderButtonsContainer = () =>{

        return(
            this.props.isCancel===false?
            <Grid item container className="alingCenter" direction='row'>
                <Grid item container className="LRepairsModalButtonCancel alingCenter">
                    <Grid id='close_repair_return_btn' item container className="alingCenter"  onClick={() => this.props.OnCancelHandler()}>
                        No, Exit 
                     </Grid>
                </Grid>
                <Grid item container className="LRepairsModalButtonClose alingCenter">
                    <Grid id='close_repair_close_btn'  item container className="alingCenter" onClick={() => this.props.OnCloseHandler()}>
                        Yes, Complete 
                     </Grid>
                </Grid>                
            </Grid>
            :
            <Grid item container className="alingCenter" direction='row'>
                <Grid item container className="LRepairsModalButtonCancel alingCenter">
                    <Grid id='cancel_repair_return_btn'  item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                        No, Exit 
                     </Grid>
                </Grid>
                <Grid item container  className="LRepairsModalButtonCancelBtn alingCenter">
                    <Grid id='cancel_repair_cancel_btn'  item container className="alingCenter" onClick={() => this.props.OnCancelRepairs()}>
                        Yes, Cancel
                    </Grid>
                </Grid>                
            </Grid>
        );
    };
    //#endregion

    render() {  
        return (            
        <main style={{}}>
            <div>
                <this.RenderModalContent actions={this.props.actions? this.props.actions : []}/>
            </div>
        </main>
        )
    }
}

function mapStateToProps(state,dispatch) {
    
    return {       
    }
}


ModalCloseRepairs = reduxForm({
    form: 'ModalCloseRepairsForm',    
    enableReinitialize: true,
})(ModalCloseRepairs);

export default connect(mapStateToProps, {})(ModalCloseRepairs);

